export class CommitChangeInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "op",
            "baseName": "op",
            "type": "ChangeOp",
            "format": ""
        },
        {
            "name": "path",
            "baseName": "path",
            "type": "string",
            "format": ""
        },
        {
            "name": "content",
            "baseName": "content",
            "type": "string",
            "format": ""
        },
        {
            "name": "fromPath",
            "baseName": "fromPath",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CommitChangeInput.attributeTypeMap;
    }
    constructor() {
    }
}
